import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import { graphql, Link } from 'gatsby';

import { Section, Layout, SEO, BlogArticles, NewsletterSection, ShareBar } from '../../components';
import { authors } from './authors';

import style from './BlogPost.module.less';

const RECOMMENDED_ARTICLES = 4;

export const BlogPost = (props) => {
  const post = props.data?.markdownRemark || {};
  const recommendedArticles = _.sampleSize(
    (props.data?.allMarkdownRemark?.edges || []).filter(({ node: article }) => {
      return article.id !== post.id;
    }),
    RECOMMENDED_ARTICLES
  );
  const authorKey: keyof typeof authors = post.frontmatter?.author;
  const author = authorKey ? authors[authorKey] : null;

  return (
    <Layout>
      <SEO
        title={`${post.frontmatter?.title} | Blog`}
        image={post.frontmatter?.image?.publicURL}
        description={post.excerpt}
      />

      <Section className={classnames(style.section, style.firstSection)}>
        <div className={classnames(style.content, style.contentNarrow, style.row)}>
          <div className={style.text}>
            <div className={style.imageWrapper}>
              <img src={post.frontmatter?.image?.publicURL} alt={post.frontmatter?.title} />
            </div>
            <h1 className={style.h1}>{post.frontmatter?.title}</h1>
            <div className={style.info}>
              <Link to="/blog">Blog</Link>
              <span className={style.separator}>•</span>
              {post.frontmatter?.date}
            </div>
            <div className={style.share}>
              <ShareBar shareUrl={props?.location?.href} title={post.frontmatter?.title} />
            </div>
            <div dangerouslySetInnerHTML={{ __html: post.html }} />
          </div>
        </div>

        {author && (
          <div className={classnames(style.content, style.contentNarrow, style.row, style.author)}>
            <div className={style.authorWrapper}>
              <div className={style.authorAvatarWrapper}>
                <img className={style.authorAvatar} src={author.avatar} alt={author.name} />
              </div>
              <div className={style.authorContent}>
                <span className={style.authorLabel}>Author</span>
                <h3>{author.name}</h3>
                {author.description}
              </div>
            </div>
          </div>
        )}
      </Section>

      <BlogArticles articles={recommendedArticles} header="Recommended articles" />

      <NewsletterSection tags={['article', (props.path as string).replace('/', '-')]} />
    </Layout>
  );
};

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      fields {
        slug
      }
      frontmatter {
        author
        title
        date(formatString: "DD MMMM, YYYY")
        image {
          publicURL
        }
      }
      excerpt
      html
    }

    allMarkdownRemark(sort: {order: DESC, fields: frontmatter___date}, limit: 15) {
      totalCount
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "DD MMM, YYYY")
            image {
              id
              relativePath
              absolutePath
              publicURL
            }
          }
          excerpt
          html
          timeToRead
        }
      }
    }
  }
`;

export default BlogPost;
